
import React, { useEffect, useRef } from 'react';
import CountdownTimer from './CountdownTimer';
import SignupForm from './SignupForm';

const HeroSection = () => {
  const heroRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;
    
    const handleMouseMove = (e: MouseEvent) => {
      const { clientX, clientY } = e;
      const { left, top, width, height } = hero.getBoundingClientRect();
      
      const x = (clientX - left) / width - 0.5;
      const y = (clientY - top) / height - 0.5;
      
      // Apply subtle tilt effect
      const elements = hero.querySelectorAll('.tilt-effect');
      elements.forEach(el => {
        if (el instanceof HTMLElement) {
          el.style.transform = `perspective(1000px) rotateY(${x * 4}deg) rotateX(${y * -4}deg)`;
        }
      });
    };
    
    hero.addEventListener('mousemove', handleMouseMove);
    
    return () => {
      hero.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  
  return (
    <section 
      ref={heroRef}
      className="parallax-container relative min-h-screen bg-black overflow-hidden flex flex-col items-center justify-center py-12 px-4"
    >
      {/* Background decorative elements */}
      <div className="absolute -top-20 -left-20 w-64 h-64 bg-floresta-acai/10 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-floresta-pistachio/20 rounded-full blur-3xl"></div>
      
      {/* Hero content container */}
      <div className="container mx-auto z-20 max-w-5xl">
        {/* Main image */}
        <div className="relative w-full mb-6 tilt-effect">
          <img 
            src="/lovable-uploads/ffd3a3de-7445-44b6-afa0-e623ffb27361.png" 
            alt="Floresta Sorvetes & Açaí" 
            className="w-full h-auto max-h-[60vh] object-contain mx-auto drop-shadow-2xl"
          />
          
          {/* Dripping caramel effect */}
          <div className="hidden md:block absolute -bottom-2 right-1/3 w-2 h-10" style={{ animation: 'drip 3s ease-in-out infinite' }}>
            <div className="w-full h-full bg-gradient-to-b from-floresta-caramel to-transparent rounded-b-full"></div>
          </div>
          <div className="hidden md:block absolute -bottom-3 right-1/4 w-2 h-12" style={{ animation: 'drip 4s ease-in-out infinite 1s' }}>
            <div className="w-full h-full bg-gradient-to-b from-floresta-caramel to-transparent rounded-b-full"></div>
          </div>
        </div>
        
        {/* Text overlay */}
        <div className="text-center mb-8 animate-floating">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 drop-shadow-md">
            Uma floresta de sabores está chegando!
          </h1>
          
          {/* Countdown timer */}
          <div className="my-8">
            <CountdownTimer />
          </div>
        </div>
        
        {/* CTA Button */}
        <div className="text-center mt-6">
          <SignupForm />
        </div>
      </div>
      
      {/* Removed the scroll indicator (seta e texto "Saiba mais") */}
    </section>
  );
};

export default HeroSection;
